import { Typography } from '@kareo/design-system';
import React from 'react';
import { formatISODateShort } from 'shared-assets/facesheet-ui/utils/patientHelper';
import { Grid, Box } from '@material-ui/core';
import FacesheetCardFooter from 'shared-assets/facesheet-ui/components/Facesheet/Card/FacesheetCardFooter';
import CachedDataWarning from '../Error/CachedDataWarning';
import { CACHED_DATA_MESSAGE } from '../../../service/patient/types';
var MedicationsContent = function (_a) {
    var hasNoKnownMedications = _a.hasNoKnownMedications, medicationsData = _a.medicationsData, cachedDate = _a.cachedDate;
    return (React.createElement(Grid, { container: true },
        cachedDate && (React.createElement(Box, { width: "100%", mb: 1.8 },
            React.createElement(CachedDataWarning, { messageType: CACHED_DATA_MESSAGE.WITH_DATE, lastCachedDate: cachedDate, displayBorder: true, addSuffix: true }))),
        hasNoKnownMedications ? (React.createElement(Grid, { item: true, xs: 12 },
            React.createElement(Typography, { variant: "body1", component: "div" }, "No known medications"))) : !medicationsData.content || medicationsData.content.length == 0 ? (React.createElement(Grid, { item: true, xs: 12 },
            React.createElement(Typography, { variant: "body1", component: "div" }, "(None documented)"))) : (React.createElement(Grid, { item: true, xs: 12 },
            React.createElement(Grid, { container: true, spacing: 1 }, medicationsData.content.map(function (item) {
                var medicationDateText = item.orderedAt
                    ? "Prescribed on " + formatISODateShort(item.orderedAt)
                    : item.filledAt
                        ? "Filled on " + formatISODateShort(item.filledAt)
                        : item.openedAt
                            ? "Started on " + formatISODateShort(item.openedAt)
                            : item.createdAt
                                ? "Entered on " + formatISODateShort(item.createdAt)
                                : undefined;
                return (React.createElement(Grid, { item: true, xs: 12, key: item.id },
                    React.createElement(Typography, { variant: "body1", component: "div" }, item.rawDrug + " (" + medicationDateText + ")")));
            })),
            React.createElement(FacesheetCardFooter, { text: medicationsData.content.length + " active medications" })))));
};
export default MedicationsContent;
